<template>
  <v-app id="app">
    <div v-if="this.$router.currentRoute.path == '/'">
      <router-view></router-view>
      <Nav></Nav>
    </div>
    <div v-else-if="this.$router.currentRoute.path == '/contact'">
      <Nav></Nav>
      <transition name="fader">
        <router-view></router-view>
      </transition>
      <t-footer2></t-footer2>
    </div>
    <div v-else>
      <Nav></Nav>
      <transition name="fader">
        <router-view></router-view>
      </transition>
      <t-footer></t-footer>
    </div>
  </v-app>
</template>

<script>
import Nav from "./components/Navigation.vue";
import Footer from "./components/Footer.vue";
import Footer2 from "./components/Footer2.vue";
export default {
  data() {
    return {};
  },
  components: {
    Nav,
    "t-footer": Footer,
    "t-footer2": Footer2,
  },
};
</script>


<style>
.fader-enter-active,
.fader-leave-active {
  transition: opacity 0.5s;
}

.fader-enter,
.fader-leave-to {
  opacity: 0;
}

.subheaders {
  text-align: center;
  margin: auto;
}

.logoText {
  font-size: 26px;
  font-weight: bold;
  color: #18519a;
  font-family: "Play", sans-serif;
  text-decoration: none;
}
</style>